import FancyAmount from '@passkeys/ui/fancy-amount';
import Skeleton from '@passkeys/ui/skeleton';
import React, { Suspense } from 'react';

import useTotalBalance from '@/ui/hooks/use-total-balance';

const LazyIntro = React.lazy(() => import('./intro'));

function Hero() {
  const { value: totalBalance, loading: isTotalBalanceLoading } =
    useTotalBalance();

  if (!isTotalBalanceLoading && totalBalance?.isZero) {
    return (
      <Suspense fallback={<div className="h-[100px] flex-shrink-0" />}>
        <LazyIntro />
      </Suspense>
    );
  }

  return (
    <div className="flex flex-col items-center gap-y-2 py-6">
      {isTotalBalanceLoading ? (
        <div className="flex items-end gap-x-1">
          <Skeleton width={143} height={52} />
          <Skeleton width={31} height={31} />
        </div>
      ) : (
        <FancyAmount value={totalBalance.toDefaultNumber()} />
      )}
    </div>
  );
}

export default Hero;
